import { ArrowLeft, Check, ShieldCheck, X } from 'lucide-react';
import { CASE_001, evidenceById } from '../case/case001';
import { useGame } from '../game/GameContext';

export function EvidenceOverlay() {
  const { state, dispatch } = useGame();
  const selectedId = state.selectedEvidenceId ?? state.discoveredEvidenceIds.at(-1) ?? 'charge-sheet';
  const evidence = evidenceById[selectedId];
  const statement = CASE_001.statements[state.activeStatementIndex];
  if (!evidence) return null;

  return (
    <div className="overlay-backdrop screen-layer">
      <section className="evidence-ledger panel-surface">
        <header className="panel-header">
          <button className="icon-action" onClick={() => dispatch({ type: 'CLOSE_OVERLAY' })}><ArrowLeft /></button>
          <div><span>COUNSEL LEDGER</span><strong>Evidence record</strong></div>
          <button className="icon-action" onClick={() => dispatch({ type: 'CLOSE_OVERLAY' })} aria-label="Close"><X /></button>
        </header>
        <div className="evidence-ledger__body">
          <nav className="evidence-ledger__index">
            {state.discoveredEvidenceIds.map((id) => {
              const item = evidenceById[id];
              return (
                <button key={id} className={id === evidence.id ? 'is-active' : ''} onClick={() => dispatch({ type: 'SELECT_EVIDENCE', evidenceId: id })}>
                  <span>{item.number}</span><div><strong>{item.title}</strong><small>{item.category}</small></div>
                  {state.viewedEvidenceIds.includes(id) && <Check size={13} />}
                </button>
              );
            })}
          </nav>
          <article className="evidence-detail" style={{ '--evidence-color': evidence.color } as React.CSSProperties}>
            <div className="evidence-detail__number">EXHIBIT / {evidence.number}</div>
            <div className="evidence-detail__object">
              <i /><i /><i />
              <span>{evidence.category}</span>
            </div>
            <p className="eyebrow">{evidence.source}</p>
            <h2>{evidence.title}</h2>
            <p className="evidence-detail__summary">{evidence.summary}</p>
            <div className="evidence-detail__analysis"><span>COUNSEL ANALYSIS</span><p>{evidence.detail}</p></div>
            <footer>
              <div><ShieldCheck /><span>Reliability</span><strong>{evidence.reliability}</strong></div>
              {evidence.timestamp && <div><span>Time mark</span><strong>{evidence.timestamp}</strong></div>}
            </footer>
            {state.phase === 'trial' && statement && (
              <button className="primary-action evidence-detail__present" onClick={() => dispatch({ type: 'PRESENT_EVIDENCE', statementId: statement.id, evidenceId: evidence.id })}>
                Present against testimony
              </button>
            )}
          </article>
        </div>
      </section>
    </div>
  );
}
